import React from 'react';

export const FBMContext = React.createContext({
    filter: null,
    toastActive: false,
    toggleToast: () => {},
    notify: null,
    setNotify: () => {},
});
